// MainForm.jsx
import React, { Component } from 'react';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
//import Confirmation from './Confirmation';
import Success from './Success_new';




class MainForm extends Component {
    userData;


    constructor(props) {
        super(props);


        this.onSubmit = this.onSubmit.bind(this);


        this.state = {
            step: 1,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            destination: '',
            type_of_insurance: '',
            country_of_residency: '',
            nationality: '',
            length_of_stay: '',
            type_of_insurance_one: null,
            type_of_insurance_json: [],
            destination_json: null,
            countryofresidency_json: null,
            nationality_one: null,
            lengthofstay_json: [],
            lengthofstay_one: null,
            post: 1,
            planmatches_json: [],
            plansall_json: [],
            countries_json: [],
            destination_country: '',
            generaltext_json: [],
            next: '',
            isLoading: false,
            nationality_country: '',
            countries_nationality_json:[]
           
            


        }
    }

    stopPost = () => {
       
        
         this.setState({
             post: 1
         })

  
         
    }

     clearStorage = () => {



         localStorage.clear();
         window.location.reload(false);

     }




    nextStep = () => {
        const { step } = this.state;
       
        this.setState({
            step: step + 1,
            next: 'next'
        })
    }

 

    prevStep = () => {
        const { step} = this.state
       
        this.setState({
            step: step - 1,
            next: ''
        })
    }

    handleChange = input => event => {
        this.setState({ [input]: event.target.value });
        this.setState({ post: 0 });
        
    }


    filter_nationality = (json, value) => {
       
        var content = '';
        json.map((obj) => {
            if (obj.id === parseInt(value)) {
                content = obj.nationality_id
            }
            return content
        })

        return content
    }


    handleChangeAutocompleteNat = (input, value) => {
 
        if (value) {
            this.setState({ [input]: value.id });
            this.setState({ nationality_one: this.state.countries_nationality_json.filter(obj => obj.id === value.id)[0] });
            this.setState({ nationality: this.filter_nationality(this.state.countries_nationality_json, value.id) });
        }
        else {
            this.setState({ [input]: '' });
            this.setState({ nationality_one: null });
            this.setState({ nationality: '' });

        }

        this.setState({ post: 0 });


    }


    filter_destination = (json, value) => {
        // var filtered = json.filter(json, { 'id': value });
        var content = '';
        json.map((obj) => {
            if (obj.id === parseInt(value)) {
                content = obj.destination_id
            }
            return content
        })

        return content
    }


    handleChangeAutocompleteDestination = (input, value) => {
        if (value) {
            this.setState({ [input]: value.id });
            this.setState({ destination_json: this.state.countries_json.filter(obj => obj.id === value.id)[0] });
            this.setState({ destination: this.filter_destination(this.state.countries_json, value.id) });
        }
        else {
            this.setState({ [input]: '' });
            this.setState({ destination_json: null });
            this.setState({ destination: '' });

        }

        this.setState({ post: 0 });


    }

    handleChangeAutocompleteCats = (input, value) => {
        if (value) {
            this.setState({ [input]: value.id });
            this.setState({ type_of_insurance_one: this.state.type_of_insurance_json.filter(obj => obj.id === value.id)[0] });
           
        }
        else {
            this.setState({ [input]: '' });
            this.setState({ type_of_insurance_one: null });
           

        }

        this.setState({ post: 0 });


    }




    handleChangeAutocompleteCountry = (input, value) => {
        if (value)
        {
            this.setState({ [input]: value.id }); 
            this.setState({ countryofresidency_json: this.state.countries_json.filter(obj => obj.id === value.id)[0] });
           
        }
        else
        {
            this.setState({ [input]: '' });
            this.setState({ countryofresidency_json: null });
           
        }
       
        this.setState({ post: 0 });
       
       
    }



    handleChangeAutocompleteLen = (input, value) => {
        if (value) {
            this.setState({ [input]: value.id });
            this.setState({ lengthofstay_one: this.state.lengthofstay_json.filter(obj => obj.id === value.id)[0] });

        }
        else {
            this.setState({ [input]: '' });
            this.setState({ lengthofstay_one: null });


        }

        this.setState({ post: 0 });


    }




  



    onSubmit(e) {
        e.preventDefault()

        this.setState({
            step: 1,
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            destination: '',
            type_of_insurance: '',
            country_of_residency: '',
            nationality: '',
            length_of_stay: '',
            post: 1,
            destination_country: '',
            next: 'next',
            isLoading: false,
            nationality_country: ''
            


        })
    }


    // React Life Cycle
    componentDidMount() {
        this.userData = JSON.parse(localStorage.getItem('user'));


        if (localStorage.getItem('user')) {
            this.setState({
                step: this.userData.step,
                firstName: this.userData.firstName,
                lastName: this.userData.lastName,
                email: this.userData.email,
                phone: this.userData.phone,
                destination: this.userData.destination,
                type_of_insurance: this.userData.type_of_insurance,
                country_of_residency: this.userData.country_of_residency,
                nationality: this.userData.nationality,
                length_of_stay: this.userData.length_of_stay,
                type_of_insurance_json: this.userData.type_of_insurance_json,
                destination_json: this.userData.destination_json,
                countryofresidency_json: this.userData.countryofresidency_json,
                lengthofstay_json: this.userData.lengthofstay_json,
                planmatches_json: this.userData.planmatches_json,
                plansall_json: this.userData.plansall_json,
                countries_json: this.userData.countries_json,
                destination_country: this.userData.destination_country,
                type_of_insurance_one: this.userData.type_of_insurance_one,
                nationality_one: this.userData.nationality_one,
                lengthofstay_one: this.userData.lengthofstay_one,
                generaltext_json: this.userData.generaltext_json,
               // next: this.userData.next,
                isLoading: this.userData.isLoading,
                nationality_country: this.userData.nationality_country,
                countries_nationality_json: this.userData.countries_nationality_json,
                post:this.userData.post
               


            })
        } else {
            this.setState({
                step: 1,
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                destination: '',
                type_of_insurance: '',
                country_of_residency: '',
                nationality: '',
                length_of_stay: '',
               // countries: '',
                destination_country: '',
               // next: '',
                isLoading: true,
                nationality_country: '',
                post:1
                


            })
        }

        ///
        var self = this;

        fetch('https://www.wellaway.com/en/sonny/api/plancategoryapi/')
            .then(function (res) {
                return res.json();
            }).then(function (json) {
                self.setState({
                    type_of_insurance_json: json
                })

            });

        //

 
        fetch('https://www.wellaway.com/en/sonny/api/lengthofstay/?format=json')
            .then(function (res) {
                return res.json();
            }).then(function (json) {
                self.setState({
                    lengthofstay_json: json
                })
            });
        //
//////////////
        fetch('https://www.wellaway.com/en/sonny/api/plansmatches/')
            .then(function (res) {
                return res.json();
            }).then(function (json) {
                self.setState({
                    planmatches_json: json
                })

            });

        //
        fetch('https://www.wellaway.com/en/sonny/api/plansapiall/')
            .then(response => response.json())
            .then(data => this.setState({
                plansall_json: data
            }));

        //

        fetch('https://www.wellaway.com/en/sonny/api/countries/')
            .then(response => response.json())
            .then(data => this.setState({ countries_json: data }));

        //
        fetch('https://www.wellaway.com/en/sonny/api/generalheadlinetext/')
            .then(response => response.json())
            .then(data => this.setState({ generaltext_json: data, isLoading: false}));

        //

        fetch('https://www.wellaway.com/en/sonny/api/countries_nationality/')
            .then(response => response.json())
            .then(data => this.setState({ countries_nationality_json: data }));

        //
        
        //////////
    }

    componentWillUpdate(nextProps, nextState) {
        localStorage.setItem('user', JSON.stringify(nextState));
    }


    render() {

        const {step} = this.state;
        const { firstName, lastName, email, phone, destination, type_of_insurance, country_of_residency, nationality, length_of_stay, type_of_insurance_json, countryofresidency_json,  lengthofstay_json, post, planmatches_json, plansall_json, countries_json, destination_country, destination_json, type_of_insurance_one, nationality_one, lengthofstay_one, generaltext_json, next, isLoading, nationality_country, countries_nationality_json } = this.state;
        const values = { firstName, lastName, email, phone, destination, type_of_insurance, country_of_residency, nationality, length_of_stay, type_of_insurance_json, countryofresidency_json, lengthofstay_json, post, planmatches_json, plansall_json, countries_json, destination_country, destination_json, type_of_insurance_one, nationality_one, lengthofstay_one, generaltext_json, next, isLoading, nationality_country, countries_nationality_json };
        switch (step) {
            case 1:
                return <Step1
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    values={values}
                    
                   

                />


            case 2:
                return <Step2
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChange={this.handleChange}
                    values={values}

                />
               
            case 3:
                return <Step3
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChangeAutocompleteNat={this.handleChangeAutocompleteNat}
                    handleChangeAutocompleteDestination={this.handleChangeAutocompleteDestination}
                    
                    values={values}

                />
             
            case 4:
                return <Step4
                    nextStep={this.nextStep}
                    prevStep={this.prevStep}
                    handleChangeAutocompleteLen={this.handleChangeAutocompleteLen}
                    handleChangeAutocompleteCats={this.handleChangeAutocompleteCats}
                    values={values}
                />
              
            //case 5:
                //return <Confirmation
                    //nextStep={this.nextStep}
                    //prevStep={this.prevStep}
                    //values={values}
               // />
            case 5:
                return <Success
                    prevStep={this.prevStep}
                    values={values}
                    clearStorage={this.clearStorage}
                    stopPost={this.stopPost}



                />
            default:
                return <Step1
                    nextStep={this.nextStep}
                    handleChange={this.handleChange}
                    values={values}


                />


        }
    }
}

export default MainForm;